import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import formatDate from "../helpers/date.helper";
import { getuser } from "../helpers/user.helper";
import { getBillsByCustomer } from "../services/bills.service";
import { GetCustomer } from "../services/customer.service";
import { createPayment } from "../services/payments";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import Footer from "../components/Footer";

function BillsTable({ load, callbackShowPayments }) {
  const handleOnclick = () => {
    callbackShowPayments();
  };

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Cliente</th>
            <th scope="col">Pedido</th>
            <th scope="col">Valor</th>
            <th scope="col">Data Pagamento</th>
            <th scope="col">
              <button className="btn-success" onClick={handleOnclick}>
                Registrar um pagamento
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {load.map((bill, index) => (
            <tr key={index}>
              <th scope="row">{bill.id}</th>
              <td>{bill.nome_cliente}</td>
              <td>{bill.cod_pedido}</td>
              <td>{bill.valor}</td>
              <td>{formatDate(bill.vencimento)}</td>
              <td></td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

function NewPaymentSection({
  customerId,
  customerName,
  paymentDate,
  paymentValue,
}) {
  let navigate = useNavigate();

  const getDate = () => {
    const date = new Date();
    return date
      .toLocaleString()
      .substring(0, date.toLocaleString().indexOf(" "));
  };

  const [optionTypeSelect, setoptionTypeSelect] = useState();
  const [valorRecebido, setvalorRecebido] = useState();
  const [numeroPedido, setnumeroPedido] = useState();

  const onsubmit = async () => {
    const bodyPayment = {
      cod_cliente: customerId,
      nome_cliente: customerName,
      valor_recebido: Number(valorRecebido),
      numero_pedido: numeroPedido,
      codigo_vendedor: getuser().sub,
      tipo_pagamento: optionTypeSelect,
    };

    let result = await createPayment(bodyPayment);
    if (result?.status === 201) {
      Swal.fire("Pagamento criado! ", "", "success");
      navigate("/pagamentos");
    } else {
      Swal.fire("Ops!", "Ocorreu um erro ao criar novo pagamento.", "error");
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card">
          <div className="card-header" style={{ cursor: "pointer" }}>
            <div className="card-tools">
              <ul className="nav nav-pills ml-auto"></ul>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-2">
                  <div className="form-group">
                    <input
                      type="text"
                      required
                      placeholder="Cód Do Cliente"
                      value={customerId}
                      className="form-control"
                      aria-describedby="codProduto"
                      name="nome"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-8">
                  <div className="form-group">
                    <input
                      type="text"
                      required
                      placeholder="Nome Cliente"
                      value={customerName}
                      className="form-control"
                      aria-describedby="codProduto"
                      name="nome"
                      readOnly="true"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-2">
                  <div className="form-group">
                    <input
                      type="text"
                      required
                      placeholder="Data do pagamento"
                      value={getDate()}
                      className="form-control"
                      aria-describedby="codProduto"
                      name="nome"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-8">
                  <div className="form-group">
                    <input
                      type="text"
                      required
                      placeholder="Valor recebido"
                      value={valorRecebido}
                      onChange={(e) => setvalorRecebido(e.target.value)}
                      className="form-control"
                      aria-describedby="codProduto"
                      name="nome"
                      readOnly={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-2">
                  <div className="form-group">
                    <input
                      type="text"
                      required
                      placeholder="Numero do pedido"
                      onChange={(e) => setnumeroPedido(e.target.value)}
                      value={numeroPedido}
                      className="form-control"
                      aria-describedby="codProduto"
                      name="nome"
                      readOnly={false}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <select
                      value={optionTypeSelect}
                      onChange={(e) => setoptionTypeSelect(e.target.value)}
                      className="form-control"
                    >
                      <option value="">Selecione uma opção</option>
                      <option value="P">PARCIAL</option>
                      <option value="T">TOTAL</option>
                    </select>
                  </div>
                </div>
                <div className="col-2">
                  <div className="form-group">
                    <button className="btn btn-primary" onClick={onsubmit}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default function Pagamentos() {
  const [customerId, setcustomerId] = useState(undefined);
  const [customerName, setcustomerName] = useState();
  const [paymentsResponse, setpaymentsResponse] = useState();
  const [showNewPayment, setshowNewPayment] = useState(false);

  const checkKeyPress = useCallback(
    (e) => {
      const { key, keyCode } = e;
      console.log(key, keyCode);
      if (keyCode === 13) {
        onLoadCustomer(customerId).then((result) => {
          console.log("search", result);
        });
      }
    },
    [customerId]
  );

  useEffect(() => {
    window.addEventListener("keydown", checkKeyPress);
    return () => {
      window.removeEventListener("keydown", checkKeyPress);
    };
  }, [checkKeyPress]);

  const onLoadCustomer = async () => {
    let result = await GetCustomer(customerId);
    if (result?.data && result?.data.length > 0)
      setcustomerName(result?.data[0].nome);
  };

  const onHandleClickShowPayment = () => {
    setshowNewPayment(true);
  };

  const onLoadPaymentsCustomer = async () => {
    let response = await getBillsByCustomer(customerId);
    setpaymentsResponse(response?.data);
  };

  const onHandleChangeCustomerId = async (customerId) => {
    setcustomerId(customerId);

    if (customerId.length === 7) {
      await onLoadCustomer();
    }
  };

  return (
    <>
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="fechamento" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">Pagamentos</h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <section className="col-lg-12 connectedSortable">
                  <div className="card">
                    <div className="card-header" style={{ cursor: "pointer" }}>
                      <div className="card-tools">
                        <ul className="nav nav-pills ml-auto"></ul>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-2">
                            <div className="form-group">
                              <input
                                type="text"
                                required
                                placeholder="Cód Do Cliente"
                                value={customerId}
                                className="form-control"
                                aria-describedby="codProduto"
                                name="nome"
                                onChange={(e) =>
                                  onHandleChangeCustomerId(e.target.value)
                                }
                                readOnly={false}
                              />
                            </div>
                          </div>
                          <div className="col-8">
                            <div className="form-group">
                              <input
                                type="text"
                                required
                                placeholder="Nome Cliente"
                                value={customerName}
                                className="form-control"
                                aria-describedby="codProduto"
                                name="nome"
                                readOnly="false"
                              />
                            </div>
                          </div>
                          <div className="col-2">
                            <div className="form-group">
                              <button
                                className="btn btn-primary"
                                onClick={() => onLoadPaymentsCustomer()}
                              >
                                Buscar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="row">
                {paymentsResponse && (
                  <BillsTable
                    load={paymentsResponse}
                    callbackShowPayments={onHandleClickShowPayment}
                  />
                )}
              </div>

              <div className="row">
                {showNewPayment && (
                  <NewPaymentSection {...{ customerId, customerName }} />
                )}
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}
